
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tnqevlrzyygegtbacfhy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRucWV2bHJ6eXlnZWd0YmFjZmh5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI0MTE3MDUsImV4cCI6MjA1Nzk4NzcwNX0.OHC-bKrHL9yi808hhFCTVgaHiO3I3C-SWPH5sJ5vL-s";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
    },
    db: {
      schema: 'public',
    },
  }
);
